import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { isMobile } from 'react-device-detect'
import { injectIntl, FormattedMessage } from 'react-intl'
import MainContentWrapper from 'core/templates/MainContentWrapper'
import {
  Form,
  Input,
  ButtonPrimary,
  Checkbox,
  Row,
  Col,
  Radio,
  RadioButton
} from 'core/components/ui'
import TitleIcon from 'core/layouts/title-icon'

const InputWrapper = styled(Row)`
  margin: 20px 0;
`

const View = props => {
  const {
    intl,
    form,
    form: { getFieldDecorator }
  } = props

  const handleSubmit = e => {
    e.preventDefault()
    form.validateFields()
  }

  const requiredRule = {
    required: true,
    message: <FormattedMessage id="ui-input-requieredField" />
  }

  return (
    <MainContentWrapper title={intl.formatMessage({ id: 'theming-view2-view-title' })}>
      <TitleIcon
        title={intl.formatMessage({
          id: 'theming-viewsubtitle'
        })}
      />

      <Form onSubmit={handleSubmit}>
        <InputWrapper type="flex" justify="center">
          {getFieldDecorator('gender', {
            rules: [requiredRule],
            initialValue: 2
          })(
            <Radio.Group buttonStyle="solid">
              <RadioButton value={2}>
                <FormattedMessage id="theming-view2-radioButton-1-reply-1" />
              </RadioButton>
              <RadioButton value={1}>
                <FormattedMessage id="theming-view2-radioButton-1-reply-2" />
              </RadioButton>
            </Radio.Group>
          )}
        </InputWrapper>
        <InputWrapper type="flex" justify="center">
          <Col span={isMobile ? 24 : 16}>
            <Form.Item>
              {getFieldDecorator('lastName', {
                rules: [requiredRule]
              })(
                <Input
                  placeholder={intl.formatMessage({
                    id: 'theming-view2-input-1-palceholder'
                  })}
                />
              )}
            </Form.Item>
          </Col>
        </InputWrapper>
        <InputWrapper type="flex" justify="center">
          <Col span={isMobile ? 24 : 16}>
            <Form.Item>
              {getFieldDecorator('firstName', {
                rules: [requiredRule]
              })(
                <Input
                  placeholder={intl.formatMessage({
                    id: 'theming-view2-input-2-palceholder'
                  })}
                />
              )}
            </Form.Item>
          </Col>
        </InputWrapper>
        <InputWrapper type="flex" justify="center">
          <Col span={isMobile ? 24 : 16}>
            <Form.Item>
              {getFieldDecorator('remember', {
                valuePropName: 'checked',
                initialValue: true
              })(
                <Checkbox>
                  <FormattedMessage id="theming-view2-checkbox" />
                </Checkbox>
              )}

              <ButtonPrimary type="primary" htmlType="submit" className="login-form-button">
                <FormattedMessage id="theming-view2-button" />
              </ButtonPrimary>
            </Form.Item>
          </Col>
        </InputWrapper>
      </Form>
    </MainContentWrapper>
  )
}

View.propTypes = {
  intl: PropTypes.shape().isRequired,
  form: PropTypes.shape().isRequired
}

export default injectIntl(Form.create({ name: 'Theming View form' })(View))
